module.exports = __webpack_public_path__ + "static/media/iphone_xr_dark.90a9b88a.svg";